const ROUTES = {

    QUESTION: '/question',
    LOGIN: '/',
    SUBMITTED: '/submitted',
    DASHBOARD: '/analysis',
    PRIVACY: '/privacy'

}

export default ROUTES;